/*=========================================================================================
  File Name: module-invoice-check-history-getters.js
  Description: InvoiceCheckHistory Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
	getInvoiceCheckHistorys(state) {
		return state.InvoiceCheckHistorys;
	}
};
